import {
  AfterViewInit, Component, ComponentFactoryResolver,
  ComponentRef, OnDestroy, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation
} from '@angular/core';
import {language} from '../../../language/vn';
import {GiaiQuyetSuVuTongHopComponent} from '../giaiquyetsuvu/tonghop/tonghop.component';
import {EmailTongHopComponent} from './tonghop/tonghop.component';
import {XuLyToTrinhComponent} from '../giaiquyetsuvu/xulytotrinh/xulytotrinh.component';
import {ThuDaGuiComponent} from './thudagui/thudagui.component';
import {ThuDaNhanComponent} from './thudanhan/thudanhan.component';
import {ThuDaXoaComponent} from './thudaxoa/thudaxoa.component';
import {ThuChuaDocComponent} from './thuchuadoc/thuchuadoc.component';
import {ThuDaDocComponent} from './thudadoc/thudadoc.component';
import {ThuDangSoanComponent} from './thudangsoan/thudangsoan.component';
import {SoanThuComponent} from './soanthu/soanthu.component';
import {ThuTempService} from '../../../service/email/service-thutemp';
import {ThuService} from '../../../service/email/service-thu';
import {DocumentDraftService} from '../../../service/draft/service-documentdraft';
import {Sessioncommand} from '../../../global/sessioncommand';
import {ActivatedRoute} from '@angular/router';
import {ThungRacComponent} from './thungrac/thungrac.component';
import {ThuGuiDaXoaComponent} from './thuguidaxoa/thuguidaxoa.component';
@Component({
  templateUrl: './email.component.html',
  encapsulation: ViewEncapsulation.None
})
export class EmailComponent implements OnInit, AfterViewInit , OnDestroy{
  @ViewChild('container', { read: ViewContainerRef })
  public viewContainerRef: ViewContainerRef;
  public showRef: ComponentRef<Object>;
  public language = language;
  public totalThuGui: number =0;
  public totalThuNhan: number =0;
  public totalThuXoa: number =0;
  public totalThuGuiXoa: number =0;
  public totalThuSoan: number =0;
  public totalThungRacNhan: number = 0;
  public totalThungRacGui: number = 0;
  public viewEmailInternal;
  public nguoiTao: number = Sessioncommand.staffId;
  public emailStatus: string = '1';
  public  colMain: string = 'col-md-9';
  public  titleCard: string = language.vanbandi;
  constructor( public componentFactoryResolver: ComponentFactoryResolver,
               public thuTempService: ThuTempService,
               public thuService: ThuService,
               public documentDraftService: DocumentDraftService,
               public route: ActivatedRoute
  ) {
  }
  ngAfterViewInit() {
    this.loadTotal();
    this.viewEmailInternal = setInterval(() => {
      if (Sessioncommand.emailStatus === 0 )
        this.loadTotal();
    }, 2000);

    this.route.queryParams.
    subscribe(params => {
      if (params.ty == null)
        this.showTongHop();
      else {
        if(params.ty == 'tdg')
          this.showThuDaGui();
        if(params.ty == 'tdn')
          this.showThuDaNhan();
        if(params.ty == 'tdx')
          this.showThuDaXoa();
        if(params.ty == 'tcd')
          this.showThuChuaDoc();
        if(params.ty == 'tdd')
          this.showThuDaDoc();
        if(params.ty == 'tds')
          this.showThuDangSoan();
        if(params.ty == 'trac')
          this.showThungRac();
      }
    });
  }
  ngOnDestroy() {
    if ( this.viewEmailInternal) {
      clearInterval(this.viewEmailInternal);
    }
  }
  public changeColMain()
  {
    if(this.colMain === 'col-md-9')
      this.colMain= 'col-md-12';
    else
      this.colMain= 'col-md-9';
  }
  public loadTotal()
  {
    Sessioncommand.emailStatus =1;
    this.thuTempService.getCountByKeyword('', this.nguoiTao, -1, 0 ).subscribe(recordCount => this.totalThuGui = recordCount);
    this.thuTempService.getCountByKeyword('', this.nguoiTao, -1, 1 ).subscribe(recordCount => this.totalThungRacGui = recordCount);
    this.thuService.getCountByKeyword('', this.nguoiTao, -1, 0 , this.emailStatus).subscribe(recordCount => this.totalThuNhan = recordCount);
    this.thuService.getCountByKeyword('', this.nguoiTao, -1, 1 , this.emailStatus).subscribe(recordCount => this.totalThungRacNhan = recordCount);
    this.documentDraftService.getCountByKeyword('','EMAIL', this.nguoiTao ).subscribe(recordCount => this.totalThuSoan = recordCount);
  }
  public showComponent(component)
  {
    const viewRef =  this.viewContainerRef;
    viewRef.clear();
    const factory = this.componentFactoryResolver.resolveComponentFactory(component);
    const comRef= viewRef.createComponent(factory);
    this.showRef= comRef;
  }
  public showSoanThu() {
    this.titleCard = language.soanthumoi;
    const viewRef =  this.viewContainerRef;
    viewRef.clear();
    const factory = this.componentFactoryResolver.resolveComponentFactory(SoanThuComponent);
    const component: ComponentRef<SoanThuComponent> = this.viewContainerRef.createComponent(factory);
    component.instance.target = '/home/email';
    this.showRef= component;
  }
  public showTongHop() {
    this.titleCard = language.tonghop;
    this.showComponent(EmailTongHopComponent);
  }
  public showThuDaGui() {
    this.colMain = 'col-md-12';
    this.titleCard = language.danhsachthu_dagui;
    this.showComponent(ThuDaGuiComponent);
  }
  public showThuDaNhan() {
    this.colMain = 'col-md-12';
    this.titleCard = language.danhsachthu_danhan;
    this.showComponent(ThuDaNhanComponent);
  }
  public showThuDaXoa() {
    this.colMain = 'col-md-12';
    this.titleCard = language.danhsachthu_daxoa;
    this.showComponent(ThuDaXoaComponent);
  }
  public showThuChuaDoc() {
    this.colMain = 'col-md-12';
    this.titleCard = language.danhsachthu_chuadoc;
    this.showComponent(ThuChuaDocComponent);
  }
  public showThuDaDoc() {
    this.colMain = 'col-md-12';
    this.titleCard = language.danhsachthu_dadoc;
    this.showComponent(ThuDaDocComponent);

  }
  public showThuDangSoan() {
    this.colMain = 'col-md-12';
    this.titleCard = language.danhsachthu_dangsoan;
    this.showComponent(ThuDangSoanComponent);

  }
  public showThungRac() {
    this.colMain = 'col-md-12';
    this.titleCard = language.thungrac;
    this.showComponent(ThungRacComponent);

  }
  public showThuGuiDaXoa() {
    this.colMain = 'col-md-12';
    this.titleCard = language.danhsach_thuguixoa;
    this.showComponent(ThuGuiDaXoaComponent);

  }
  ngOnInit(): void {
    Sessioncommand.sideBarActive = true;
  }



}

